<slotcom-navigation-button
  type="close"
  (click)="closeModal()"></slotcom-navigation-button>

<div class="dark-background">
  <slotcom-wallet [type]="'Gems'"></slotcom-wallet>
  <div class="img-container">
    <div
      class="img-logo"
      theming
      themingGroup="dailychallenge"
      themingAsset="logo"
      [themingOverride]="completeWithGemsModalData?.data?.dailyChallenge?.assets"></div>
    <div
      class="img-background"
      theming
      themingGroup="dailychallenge"
      themingAsset="spend-gems-background"
      [themingOverride]="completeWithGemsModalData?.data?.dailyChallenge?.assets"></div>
  </div>
  <div class="text-container">
    <slotcom-p
      class="text-title"
      data-testid="dailyChallenge-completeWithGems-popup-title"
      [bold]="true"
      [text]="'home.daily-challenge.complete-with-gems.title' | translate | uppercase"
      [shadowBorder]="true"></slotcom-p>
    <slotcom-p
      class="text-confirmation"
      [bold]="true"
      [text]="confirmationText"
      [shadowBorder]="true"></slotcom-p>
  </div>
  <slotcom-button
    class="custom-button c-button--pink unlock-button"
    data-testid="dailyChallenge-completeWithGems-popup-button"
    [isLoading]="loading()"
    (safeClick)="completeChallenge()"
    audioType="payment">
    <span class="gem-icon"></span>
    <span class="label">{{ completeWithGemsModalData.data.challenge.gemsToComplete }}&nbsp;</span>
  </slotcom-button>
</div>

<slotcom-animated-timer
  class="d-none"
  [endDate]="completeWithGemsModalData?.data?.dailyChallenge?.properties?.challengestatuses[0]?.endDate"
  (expired)="closeModal()"></slotcom-animated-timer>
